/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { InputPromotionCodeEntrance } from 'apollo/types';

const entranceTicketTypeMapper = (formValues: any) => {
  const entrances: InputPromotionCodeEntrance[] = [];
  let counter = 1;

  Object.keys(formValues).forEach((key) => {
    if (key.includes('entranceTicketType')) {
      const entranceTicketTypeId = key.split('_')[2];
      const prop = key.split('_')[0];

      let maxQuantity = 0;
      let percentageDiscount = 0;
      let edited = false;

      if (prop === 'discountPercentage' && counter % 2 !== 0) {
        if (formValues[key] !== undefined) {
          edited = true;
          percentageDiscount = formValues[key] as number;
        } else {
          percentageDiscount = 0;
        }
        entrances.push({
          entranceTicketTypeId,
          maxQuantity,
          percentageDiscount,
          edited,
        });
        counter += 1;
      } else if (prop === 'maxTickets' && counter % 2 === 0) {
        if (formValues[key] !== undefined) {
          edited = true;
          maxQuantity = formValues[key] as number;
        } else {
          maxQuantity = 0;
        }
        entrances.forEach((entrance, index) => {
          if (entrance.entranceTicketTypeId === entranceTicketTypeId) {
            entrances[index] = {
              entranceTicketTypeId,
              maxQuantity,
              percentageDiscount: entrances[index].percentageDiscount,
              edited,
            };
            counter = 1;
          }
        });
      }
    }
  });

  return { entrances };
};

export default entranceTicketTypeMapper;
